import axios from 'axios';
import { promptAction } from './PromptSlice';

const getPromptData = (prompt, token, signal) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/api/prompt`;
      const body = { prompt };
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.post(url, body, { headers, signal });
      return response;
    };
    try {
      const result = await fetchData();
      const promptData = result.data;
      dispatch(promptAction.promptHandler({ promptData }));
    } catch (e) {
      const errorData = e?.response?.data || { error: e.message || "unknown_error" };
      dispatch(promptAction.promptHandler({ error: errorData }));
    }
  };
};

export default getPromptData;